import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 20px;
  font-size: 60px;
  color: #4f7bae;
`;
